import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  IconButton,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";
import { styles } from "utils/apis";
import StackGarmentForm from "./stackGarmentForm";

const StackGarmentDrawer = ({
  mode,
  open,
  handleClose,
  setRender,
  productoData,
  setFieldValue
}) => {
  return (
    <div>
      <Dialog
        open={open}
        // onClose={handleClose}
        style={{ padding: 10 }}
        fullWidth
        maxWidth={"lg"}
      >
        <DialogTitle
          sx={{ display: "flex", justifyContent: "flex-end", padding: 0 }}
        >
          <IconButton onClick={handleClose} sx={{ color: "purple" }}>
            <Cancel />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <StackGarmentForm
            mode={mode}
            handleClose={handleClose}
            setRender={setRender}
            productoData={productoData}
            setFieldValue={setFieldValue}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default StackGarmentDrawer;
